import { useRouter } from 'expo-router'
import { useCallback, type ReactNode } from 'react'
import { ScrollView, View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Message } from '@/src/elements/message'
import { Typography } from '@/src/elements/text/Typography'
import { GuideLinks } from '@/src/features/guide/ui/components/GuideLinks'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

import { RosarioBloc } from '../components/RosarioBloc/RosarioBloc'

export const LeaveScreen = (): ReactNode => {
  const { t } = useTranslate()
  const router = useRouter()
  const { routes } = useRoutes()

  const goToHomePage = useCallback(() => {
    router.replace(routes.home())
  }, [router, routes])

  return (
    <ScrollView testID={TEST_ID.LEAVE.SCREEN} className="flex-1 py-24">
      <View className="container w-full max-w-screen-md gap-10 px-16">
        <Button
          onPress={goToHomePage}
          startIcon={ICON.CHEVRON_LEFT}
          variant="faded"
          colors="primary"
          className="self-start"
        >
          {t('words.home-page')}
        </Button>

        <View className="gap-6">
          <Message colors="success" iconName={ICON.CHECK_CIRCLE_BROKEN}>
            {t('leave.confirm.message')}
          </Message>

          <Typography>{t('leave.sign-up-again')}</Typography>
        </View>

        <View>
          <Typography size="2xl" black className="text-primary-page-title">
            {t('leave.pray-differently')}
          </Typography>
        </View>

        <RosarioBloc />

        <View className="gap-6">
          <Typography black center size="lg" colors="primary">
            {t('leave.guides-title')}
          </Typography>
          <GuideLinks />
        </View>
      </View>
    </ScrollView>
  )
}
